module.exports = __webpack_public_path__ + "static/img/banner_bg4.aa107c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg4.jpg
// module id = 7m7c
// module chunks = 9